import angular from "angular";
import panel from "../services";

function resizeTextArea(panel) {
    var emojiConfig = {
        height: '200px',
        width:'350px',
        iconBackgroundColor:'#fefefe',
        iconColor:'black'
    };

    return {
        restrict: 'A',
        link: (scope, element) => {
            $(element).autoHeightTextarea().emojiPicker(emojiConfig);
        }
    }
}

export default angular.module('directives.resizeTextArea', [panel]).directive('resizeTextArea', resizeTextArea).name;


// WEBPACK FOOTER //
// ./src/app/directives/resizeTextArea.js